export const STORAGE_PARTITION_WAREHOUSE_TYPES = ['client', 'fulfillment']

export function getStoragePartitionWarehouseFilters () {
  return [
    {
      type: 'in',
      field: 'type',
      values: [...STORAGE_PARTITION_WAREHOUSE_TYPES]
    }
  ]
}
